module.exports = __webpack_public_path__ + "static/media/lobby.73325933.mp3";